<template>
    <div class="tcu-card _program">
        <a :href="card._href">
            <div class="tcu-card-thumbnail">
                <img :src="card.cardimg.img._src" alt="Card Image">
            </div>

            <div class="tcu-card-content">
                <div class="program tcu-oswald">{{ card.name | capitalize() }}</div>
                <span class="divider"></span>
                <p class="program-majors">
                    {{ card.degreetext}}
                    <!-- {{ degrees }} -->
                </p>
            </div>
        </a>
    </div>
    <!--/ End .tcu-card._program -->
</template>

<script>
export default {
  data() {
    return {
      // list of tags for giving each schools a different color - maybe a feature later
    };
  },

  props: {
    // this component expects a prop of type object
    card: Object
  },
  filters: {
    // this filter is used to capitalize the name
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AcademicCard.vue